import { SliderScroll } from '../_app/cuchillo/components/SliderScroll';
import { Scroll } from '../_app/cuchillo/scroll/Scroll';
import { gsap } from "gsap";
import VScroll_Item from '../_app/cuchillo/scroll/VScroll_Item';
import { GetBy } from '../_app/cuchillo/core/Element';
import { isSmartphoneOnlyWidth, isTouch } from '../_app/cuchillo/core/Basics';
import { Draggable } from "gsap/Draggable";

class ScrollItem__SliderDefaultNoTouch extends VScroll_Item {
    _call;
    _slider;

    //==================================================================================================================
    //          CONSTRUCTOR
    //==================================================================================================================
    constructor(__link, __index, __scroller) {
        super(__link, __index, __scroller);

        if (!isSmartphoneOnlyWidth) {
            this._slider = new SliderScroll(__link, {
                interaction: true,
                hasScrollbar: true,
                itemClass: ScrollItem__SliderImages__Item,
                domControls: GetBy.class("__controls", __link)[0],
            });
        } else {
            const x1 = GetBy.selector("[scroll-slider-item]", __link)[0].getBoundingClientRect().left;
            const x2 = GetBy.selector("[scroll-slider-item]", __link)[1].getBoundingClientRect().left;
            const gridWidth = x2 - x1;

            Draggable.create(GetBy.class("__holder", __link)[0], {
                type: "x",
                edgeResistance: 0.85,
                dragResistance: .1,
                bounds: GetBy.class("__slider", __link)[0],
                inertia: true,
                snap: {
                    x: function (endValue) {
                        return Math.round(endValue / gridWidth) * gridWidth;
                    }
                }
            });
        }

        this._call = () => this.loop();
        this.onShow = () => {
            gsap.ticker.add(this._call);
        };

        this.onHide = () => {
            gsap.ticker.remove(this._call);
        };
    }

    resize(w, h) {
        super.resize(w, h);
        if (this._slider) this._slider.resize();
    }

    loop() {
        if (this._slider) this._slider.loop();
    }

    dispose() {
        if (this._slider) this._slider.dispose();
        super.dispose();
    }
}

class ScrollItem__SliderImages__Item extends VScroll_Item {
    hasHiddenEnabled = false;
    info;

    //==================================================================================================================
    //          CONSTRUCTOR
    //==================================================================================================================

    constructor(__link, __index, __scroller) {
        super(__link, __index, __scroller);
    }

    //==================================================================================================================
    //          PUBLIC
    //==================================================================================================================

    //update () {
    /* if (this.progress > .5) {
       const p = Math.max(0, Maths.normalize(1, .5, this.progress));
       this._x = this._x + ((Metrics.WIDTH * .5) * p);
     }*/
    /* super.update();
  }

  mouseOver () { }
  mouseDown () { }
  mouseUp () { }

  show () {
    super.show();
  }

  hide () {
    super.hide();
  }*/
}

Scroll._registerClass('SliderDefaultNoTouch', ScrollItem__SliderDefaultNoTouch);
